import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  templateUrl: './loading-indicator.component.html',
  styleUrls: ['./loading-indicator.component.scss'],
})
export class LoadingIndicatorComponent implements OnInit {
  @Input('text') text: string = 'Please wait...';
  @Input('internal') internal: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
